
import { Component, Vue } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import LocationInputMap from '@/components/Forms/Components/LocationInputMap.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { EnrollOwner, UserTypes } from '@/store/models/user';
import { UserStore } from '@/store/modules';
import helpers from '@/utils/helpers';

@Component({
  meta: {
    title: 'Create an Account'
  },
  components: {
    QvInput,
    QvSelect,
    ValidationProvider,
    ValidationObserver,
    LocationInputMap
  }
})
export default class EnrollManagerPage extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  isConfirmPwd = true;
  isPwd = true;
  uid = '';
  farmUid = '';
  token = '';

  farmName = '';
  validatingToken = false;
  isTokenValid = true;
  readOnlyEmail = false;

  // eslint-disable-next-line
  enrollOwner: EnrollOwner = {
    uid: '',
    token: '',
    userDetail: {
      customUser: {}
    }
  } as EnrollOwner;

  async onSubmit() {
    this.enrollOwner.uid = this.uid;
    this.enrollOwner.token = this.token;
    this.enrollOwner.userDetail.email = this.enrollOwner.userDetail.email.toLowerCase();
    const enrollOwner = new FormData();
    const data = helpers.getNestedFormData(enrollOwner, this.enrollOwner);
    await UserStore.enrollOwner(data);
    this.$q.notify({
      type: 'positive',
      message: `An activation mail has been sent to your email.`,
      caption: `Please follow the instruction in email to continue.`,
      timeout: 10000
    });
    this.$router.push({ name: 'LandingPage' });
  }
  onReset() {
    // eslint-disable-next-line
    this.enrollOwner = { userDetail: { customUser: {} } } as EnrollOwner;
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
    });
  }

  imgtag: { src: string | null | ArrayBuffer; title: string } = {
    src: '',
    title: ''
  };

  onImageInput(file: File | null) {
    if (file) {
      const reader = new FileReader();

      this.imgtag.title = file.name;

      reader.onload = event => {
        if (event && event.target) {
          this.imgtag.src = event.target.result;
        }
      };

      reader.readAsDataURL(file);
    } else {
      this.imgtag = { src: '', title: '' };
    }
  }

  async created() {
    if (this.$route.params.uid) {
      this.uid = this.$route.params.uid;
      this.enrollOwner.uid = this.uid;
    }
    if (this.$route.params.token) {
      this.token = this.$route.params.token;
      this.enrollOwner.token = this.token;
    }
    this.validatingToken = true;
    await UserStore.validateInviteToken({
      uid: this.uid,
      token: this.token,
      farmUid: this.farmUid,
      userType: UserTypes.OWNER
    })
      .then(res => {
        if (res.farmName) {
          this.farmName = res.farmName;
        }
        if (res.isValid) {
          this.isTokenValid = res.isValid;
        }
        if (res.email) {
          this.enrollOwner.userDetail.email = res.email;
          this.readOnlyEmail = true;
        }
      })
      .catch(() => {
        this.isTokenValid = false;
      });
    this.validatingToken = false;
  }
}
